import AuthService from "../auth";
import { setAuthToken } from "../sessions/auth_session";
import {HttpActualGet, HttpActualPost, HttpActualPostParams, HttpActualPut, HttpActualDelete, HttpActualPut1, HttpActualPutParamsPayload, HttpActualPutPayload, HttpActualPutParams} from "./HttpCoreOperation";
import { useRBACStore } from "../../../plugins/RBACPlugin";

const SBMA_SUB_KEY =  process.env.REACT_APP_APPOINTMENT_SBMA_SUB_KEY

let profile_uid = localStorage.getItem("profile_uid")

// subscribe profile id changes from RBAC plugin store
// useRBACStore.subscribe((state) => {
//   profile_uid = state.profileId
// });

const HttpAuthGet = async (path, parameters = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualGet(path, parameters, subscriptionKey, xProfileUid); // Proceed without the token
    }


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualGet(path, parameters, subscriptionKey , xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualGet(path, parameters, subscriptionKey , "", "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthPost = async (path, payload = null, subscriptionKey = null, xProfileUid = null) => {
    
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();
    

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPost(path, payload, subscriptionKey, xProfileUid); // Proceed without the token
    }


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPost(path, payload, subscriptionKey , xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPost(path, payload, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthPostParams = async (path, parameters = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();
    

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPostParams(path, parameters, subscriptionKey, xProfileUid); // Proceed without the token
    }


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPostParams(path, parameters, subscriptionKey , xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPostParams(path, parameters, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthPutParamsPayload = async (path, parameters, payload, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPutParamsPayload(path, parameters, payload, subscriptionKey, xProfileUid); 
    }


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPutParamsPayload(path, parameters, payload, subscriptionKey, xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPutParamsPayload(path, parameters, payload, subscriptionKey, xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT_PARAMETERS_PAYLOAD", error)
            reject(error)
        }
    })

    return promise
}


const HttpAuthPut = async (path, payload = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    // return HttpActualPut(path, parameters, payload, subscriptionKey, accessToken);
    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPut(path, payload, subscriptionKey, xProfileUid); // Proceed without the token
    }


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPut(path, payload, subscriptionKey , xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPut(path, payload, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthPutPayload = async (path, payload = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPutPayload(path, payload, subscriptionKey, xProfileUid);
    }

    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPutPayload(path, payload, subscriptionKey, xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPutPayload(path, payload, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthPutParams = async (path, parameters = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPutParams(path, parameters, subscriptionKey, xProfileUid);
    }

    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPutParams(path, parameters, subscriptionKey, xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("HttpActualPutParams error: ", err)
                })
            } else {
                const result = HttpActualPutParams(path, parameters, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT_PARAMS", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthPut1 = async (path, parameters= "", payload = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualPut1(path, payload, subscriptionKey, xProfileUid); // Proceed without the token
    }


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPut1(path, parameters, payload, subscriptionKey , xProfileUid, accessToken)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPut(path, parameters, payload, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise
}

const HttpAuthDelete = async (path, parameters = null, subscriptionKey = null, xProfileUid = null) => {
    if (!subscriptionKey) {
        subscriptionKey = SBMA_SUB_KEY;
    }

    if(!xProfileUid){
        xProfileUid = profile_uid;
    }

    let isAuthenticated = AuthService.isUserLoggedIn();

    if (!isAuthenticated) {
        console.warn("No access token available, proceeding without it.");
        return HttpActualDelete(path, parameters, subscriptionKey, xProfileUid);
    }

     var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualDelete(path, parameters, subscriptionKey, xProfileUid, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualDelete(path, parameters, subscriptionKey , xProfileUid, "")
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_DELETE", error)
            reject(error)
        }
    })

    return promise
}


export {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthDelete, HttpAuthPostParams, HttpAuthPut1, HttpAuthPutParamsPayload, HttpAuthPutPayload, HttpAuthPutParams}
